export const getAccessToken = (
    request,
    instance,
    callback,
    callbackObj,
    storageObj,
    showModalCallback = null,
    isInteractive = false
) => {
    instance
        .acquireTokenSilent(request)
        .then((response) => {
            callback({ token: response.accessToken, ...callbackObj });
            if (storageObj !== null && localStorage.getItem(storageObj.key) === storageObj.value) {
                localStorage.removeItem(storageObj.key);
            }
        })
        .catch((e) => {
            // store what's happening before redirect, see login-signup-modal
            if (storageObj !== null) {
                localStorage.setItem(storageObj.key, storageObj.value);
            }

            if (isInteractive) {
                instance.acquireTokenRedirect(request).catch((error) => console.error(error));
            } else {
                if (!!showModalCallback) {
                    showModalCallback();
                }

                console.warn('acquireTokenSilent exception - logout user');
                instance.logoutRedirect({
                    onRedirectNavigate: (url) => {
                        return false; // To do a local signout without any redirection
                    },
                });
            }
        });
};
